module.exports = __webpack_public_path__ + "img/house_ad_details.bda296a0.png";